import { gql } from "@apollo/client";

export const USE_ADVANTAGE = gql`
  mutation useAdvantage($input: UseAdvantageInput!) {
    results: useAdvantage(input: $input) {
      code
      message
      error
      data {
        _id
        programId
        clientId
      }
    }
  }
`;
